import React from 'react';

interface AvatarProps {
  src: string;
  alt: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function Avatar({ src, alt, size = 'md', className = '' }: AvatarProps) {
  const sizeStyles = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12'
  };

  return (
    <img
      src={src}
      alt={alt}
      className={`
        rounded-full ring-2 ring-blue-500/20 object-cover
        ${sizeStyles[size]}
        ${className}
      `}
    />
  );
}